export const MCP_DOCS_URL = "https://developers.redo.com/docs/mcp-server/setup";
